module.exports = __webpack_public_path__ + "media/images/sampleBet__deco-91acee65b2b32634309414d691566893.png";